import {
  IS_TESTNET,
  provider,
  wagmiConfig
} from '@/constants/walletConnectionConfig'
import { signTypedData } from '@wagmi/core'
import {
  FUNDS_RECEIVER_WALLET_ADDRESS,
  SECH_ABI,
  SIGNATURE_DOMAIN,
  TOKEN_CONTRACT_ADDRESS,
  SIGNATURE_TYPES
} from '@/constants'
import { ethers, parseEther } from 'ethers'

//TODO: in case of gas issues use this method to calculate gas price before preparing transaction data
//  and add some buffer to prevent insufficient gas errors
// const estimatedGas = await estimateGas(wagmiConfig, {
//   account: TOKEN_CONTRACT_ADDRESS,
//   to: TOKEN_CONTRACT_ADDRESS,
//   data: encodeFunctionData({
//     abi: SECH_ABI,
//     functionName: 'execute',
//     args: [
//       {
//         from: userAddress,
//         to: TOKEN_CONTRACT_ADDRESS,
//         value: 0n,
//         gas: 0n, // Placeholder
//         nonce,
//         data: transferData
//       },
//       '0x' // Placeholder signature
//     ]
//   })
// })

// const gasLimit =(estimatedGas * 11n) / 10n

interface MetaTransactionParams {
  userAddress: `0x${string}`
  amount: string
}

export async function getSignedTransactionData({
  userAddress,
  amount
}: MetaTransactionParams) {
  console.log({
    amount,
    userAddress,
    TOKEN_CONTRACT_ADDRESS,
    FUNDS_RECEIVER_WALLET_ADDRESS
  })
  try {
    const tokenContract = new ethers.Contract(
      TOKEN_CONTRACT_ADDRESS,
      SECH_ABI,
      provider
    )
    const nonce = await tokenContract.getNonce(userAddress)

    const amountInWei = parseEther(amount)
    // console.log({ amountInWei })

    // Signature message
    const transferRequest: any = {
      from: userAddress,
      to: FUNDS_RECEIVER_WALLET_ADDRESS,
      amount: amountInWei.toString(),
      nonce: Number(nonce)
    }

    // console.log('Transfer request info:\n', transferRequest)
    if (!IS_TESTNET) {
      transferRequest.deadline = Math.floor(Date.now() / 1000) + 3600
    }

    // Request user signature
    const signature = await signTypedData(wagmiConfig, {
      domain: SIGNATURE_DOMAIN,
      types: SIGNATURE_TYPES,
      primaryType: 'TransferRequest',
      message: transferRequest
    })

    // console.log({
    //   SIGNATURE_DOMAIN,
    //   transferRequest,
    //   signature
    // })

    return { signedTx: signature, txNonce: Number(nonce), transferRequest }
  } catch (error) {
    console.error('Error preparing meta transaction:', error)
    throw error
  }
}
